export const RoutingEnum = Object.freeze({
  aboutUs: '/about-us',
  home: '/',
  contact: '/contact',
  cookiePolicy: '/cookie-policy',
  search: '/results',
  jobSearch: '/careers/job-search',
  jobSearchWithTrailing: '/careers/job-search/',
  news: '/news',
  notFound: '/404',
  jobNotFound: '/careers/job-search/job-not-found',
  policiesReportsAndCertifications:
    '/sustainability/policies-reports-and-certifications',
  secFilings: '/investors/sec-filings',
  story: '/about-us/stories',
  sustainability: '/sustainability',
})

export default RoutingEnum
